import { jsx } from 'react/jsx-runtime';
import { Skeleton, Breadcrumbs as Breadcrumbs$1 } from '@tecsinapse/cortex-react';
import { generateBreadcrumbs } from '../utils/breadcrumbs.js';
import { useLocation } from 'react-router-dom';
import { useMenuQuery } from '../../core/hooks/use-menu-query.js';

const Breadcrumbs = ({
  currentProduct
}) => {
  const {
    data: menu,
    isLoading
  } = useMenuQuery();
  const {
    pathname
  } = useLocation();
  const breadcrumbs = generateBreadcrumbs(menu?.menus ?? [], pathname, currentProduct);
  return /* @__PURE__ */ jsx("div", { className: "max-w-[1440px] w-[calc(100%-32px)] my-deca mx-auto hidden sm:flex", children: isLoading ? /* @__PURE__ */ jsx(Skeleton, { className: "h-[31px] rounded-mili w-full" }) : /* @__PURE__ */ jsx(Breadcrumbs$1, { breadcrumbs }) });
};

export { Breadcrumbs as default };
